import HttpClient from '../HttpService';

function listByPatientUuid(patientUuid) {
    return HttpClient.get(`/patients/uuid/${patientUuid}/evolutions`);
}

function create(patientUuid, data) {
    return HttpClient.post(`/patients/uuid/${patientUuid}/evolutions`, data);
}

export default { listByPatientUuid, create };
